import { render, staticRenderFns } from "./settingLinkSave.vue?vue&type=template&id=4a6cf0d0&scoped=true&"
import script from "./settingLinkSave.vue?vue&type=script&lang=js&"
export * from "./settingLinkSave.vue?vue&type=script&lang=js&"
import style0 from "./settingLinkSave.vue?vue&type=style&index=0&id=4a6cf0d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6cf0d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
